import { ObservableArray, View } from "binder"
import { ThemeSelectorViewModel } from "../themeSelector/themeSelector-viewModel";
import { FilterAccessibleFormsViewModel, UserMainWindowViewModel } from "./userMainWindow-viewModel"
import { WindowContainerViewModel } from "./windowContainer/windowContainer-viewModel";

export class UserMainWindowView extends View<UserMainWindowViewModel>{
    GetViewUniqueId(): string {
        return "V-C05C9004-A8EB-4613-9779-E3FCCE51A221"
    }
    loadHtml(): string {
        let element = require('./userMainWindow.html').default;
        let style = require('./userMainWindow.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set forms(v: ObservableArray<WindowContainerViewModel>) { this._forms = v; } public get forms(): ObservableArray<WindowContainerViewModel> { return this._forms;} private _forms: ObservableArray<WindowContainerViewModel>;
    public set currentForm(v: WindowContainerViewModel) { this._currentForm = v; } public get currentForm(): WindowContainerViewModel { return this._currentForm;} private _currentForm: WindowContainerViewModel;
    public set filter(v: FilterAccessibleFormsViewModel) { this._filter = v; } public get filter(): FilterAccessibleFormsViewModel { return this._filter;} private _filter: FilterAccessibleFormsViewModel;
    public set loggedInPersonnelName(v: string) { this._loggedInPersonnelName = v; } public get loggedInPersonnelName(): string { return this._loggedInPersonnelName;} private _loggedInPersonnelName: string;
    public set loggedInPersonnelCode(v: string) { this._loggedInPersonnelCode = v; } public get loggedInPersonnelCode(): string { return this._loggedInPersonnelCode;} private _loggedInPersonnelCode: string;
    public set autohide(v: boolean) { this._autohide = v; } public get autohide(): boolean { return this._autohide;} private _autohide: boolean;
    public set themeWindow(v: ThemeSelectorViewModel) { this._themeWindow = v; } public get themeWindow(): ThemeSelectorViewModel { return this._themeWindow;} private _themeWindow: ThemeSelectorViewModel;
    public set shallShowThemes(v: boolean) { this._shallShowThemes = v; } public get shallShowThemes(): boolean { return this._shallShowThemes;} private _shallShowThemes: boolean;
    
    toggleAutohide(){
        this.dataContext.toggleAutohide();
    }

    showThemeWindow(){
        this.dataContext.showThemeWindow();
    }

    logout(){
        this.dataContext.logout();
    }
}
